import React, { useEffect, useState } from 'react';
import { getPlanDetail } from '../../api/subscription';
import { useLocation } from 'react-router-dom';
import Lopa from '../../assets/LopaaLogo.png';
import AccountSetupInputBox from '../../common/AccountSetupInputBox';

interface Iprops {
  uuid: string
}
const Payment = () => {

  // const { uuid } = props;

  const location = useLocation();
  const { uuid } = location.state || {};

  const [planDetail, setPlanDetail] = useState<any>();
  const [planDetailForm, setPlanDetailForm] = useState<any>({
    firstName: '',
    companyName: '',
    country: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    gstin: '',
    cardNumber: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    securityCode: '',
    checkTerms: false
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(true);


  const getsubscriptionPlan = async () => {
    try {
      const data = await getPlanDetail(uuid);
      const dashboardData = data?.payload as any;
      setPlanDetail(dashboardData);
    } catch (err: any) {
      console.error('Error fetching data', err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getsubscriptionPlan()
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    setPlanDetailForm({ ...planDetailForm, [name]: value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  const handleCheckboxChange = (value: string) => {
    setPlanDetailForm({ ...planDetailForm, checkTerms: value ? true : false });
  };


  return (
    <div className="h-full px-11">
      <div>
        <div className="lg:mb-14 my-6 flex items-center">
          <img src={Lopa} className="lg:w-40 lg:h-20 w-32 h-16" alt="Matrix AI" />
        </div>
      </div>
      <div className='flex w-full gap-7'>
        <div className='basis-3/5 border-2 border-[#343434] rounded-xl'>
          <form action="">
            <div className=' px-4 py-5'>
              <div className='text-4xl font-semibold '>Set up your Plan</div>
              <div className='text-sm font-normal mt-5'>Licensee note: The licensee will hold item licenses and be the billing contact for this account.
                You can nominate either your company or yourself to be the licensee.</div>
              <div className='text-2xl mt-7'>Select Licence</div>
              <div className='flex gap-6 mt-4 mb-8'>
                <div className='flex'>
                  <input type="radio" name='licenceType' value={'myCompany'} />
                  <label htmlFor="licenceType" className='text-base'>My Company</label>
                </div>
                <div className='flex'>
                  <input type="radio" name='licenceType' value={'individual'} />
                  <label htmlFor="licenceType" className='text-base mr-1'>Me, as an individual</label>
                </div>
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="firstName"
                  type="text"
                  value={planDetailForm.firstName}
                  placeholder="First Name"
                  handleChange={handleChange}
                  error={errors.firstName}
                />
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="companyName"
                  type="text"
                  value={planDetailForm.companyName}
                  placeholder="Company Name"
                  handleChange={handleChange}
                  error={errors.companyName}
                />
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="country"
                  type="text"
                  value={planDetailForm.country}
                  placeholder="country"
                  handleChange={handleChange}
                  error={errors.country}
                />
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="address1"
                  type="text"
                  value={planDetailForm.address1}
                  placeholder="Address 1"
                  handleChange={handleChange}
                  error={errors.address1}
                />
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="address2"
                  type="text"
                  value={planDetailForm.address2}
                  placeholder="Address 2"
                  handleChange={handleChange}
                  error={errors.address2}
                />
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="city"
                  type="text"
                  value={planDetailForm.city}
                  placeholder="City"
                  handleChange={handleChange}
                  error={errors.city}
                />
              </div>
              <div className='w-full mt-4 flex'>
                <div className='basis-2/4 mr-5'>
                  <AccountSetupInputBox
                    name="state"
                    type="text"
                    value={planDetailForm.state}
                    placeholder="State / Province / Region"
                    handleChange={handleChange}
                    error={errors.state}
                  />
                </div>
                <div className='basis-2/4'>
                  <AccountSetupInputBox
                    name="zipCode"
                    type="text"
                    value={planDetailForm.zipCode}
                    placeholder="Zip / Post Code"
                    handleChange={handleChange}
                    error={errors.zipCode}
                  />
                </div>
              </div>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="gstin"
                  type="text"
                  value={planDetailForm.gstin}
                  placeholder="GSTIN"
                  handleChange={handleChange}
                  error={errors.gstin}
                />
              </div>

            </div>
            <hr className='border-[#343434] border-2' />
            <div className=' px-4 py-5'>
              <div className='mt-4'>
                <AccountSetupInputBox
                  name="cardNumber"
                  type="text"
                  value={planDetailForm.cardNumber}
                  placeholder="Card number"
                  handleChange={handleChange}
                  error={errors.cardNumber}
                />
              </div>
              <div className='w-full mt-4 flex'>
                <div className=' mr-4'>
                  <AccountSetupInputBox
                    name="cardExpiryMonth"
                    type="text"
                    value={planDetailForm.cardExpiryMonth}
                    placeholder="Expiry Month"
                    handleChange={handleChange}
                    error={errors.cardExpiryMonth}
                  />
                </div>
                <div className='mr-4'>
                  <AccountSetupInputBox
                    name="cardExpiryYear"
                    type="text"
                    value={planDetailForm.cardExpiryYear}
                    placeholder="Expiry Year"
                    handleChange={handleChange}
                    error={errors.cardExpiryYear}
                  />
                </div>
                <div className='mr-4'>
                  <AccountSetupInputBox
                    name="securityCode"
                    type="text"
                    value={planDetailForm.securityCode}
                    placeholder="Security Code"
                    handleChange={handleChange}
                    error={errors.securityCode}
                  />
                </div>
              </div>
              <div className='flex gap-8'>
                <input
                  type="checkbox"
                  id={'checkTerms'}
                  className="h-5 w-5 text-blue-600 border-gray-300 rounded mt-2"
                  checked={planDetailForm.checkTerms}
                  onChange={() => handleCheckboxChange('checkTerms')}
                />
                <label htmlFor="checkTerms">
                  By subscribing to Matrix Ai, you confirm you are 18 or over, and that you agree to our Privacy Policy,
                  License Terms, and User Terms including our Fair Use Policy.
                </label>
              </div>
            </div>

          </form>
        </div>

        <div className='basis-2/5 border-2 border-[#343434] rounded-xl px-4 py-5 h-[100%]'>
          <div className='text-4xl font-semibold '>Order Summery</div>
          <div className='text-2xl font-semibold mt-7 ' >Billing cycle</div>
        </div>

      </div>
    </div>
  );
};
export default Payment;
